import type { InputHTMLAttributes } from "react";
import { cn } from "./utils";
import AdminTextInput from "./AdminTextInput";

interface AdminSearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  value: string;
  onChange: (value: string) => void;
}

const AdminSearchInput = ({ value, onChange, className, placeholder = "검색어 입력", ...props }: AdminSearchInputProps) => {
  return (
    <div className={cn("relative", className)}>
      <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400" />
      <AdminTextInput
        {...props}
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="pl-9 pr-3"
      />
    </div>
  );
};

export default AdminSearchInput;
